<template>
<div>
  <div class="horizontal">
    <div class="left">人員計画</div>
    <div class="right">
      <table class="table-connection">
        <thead>
          <tr>
            <th>分類</th>
            <th>人数</th>
            <th>詳細</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(position, index) in item.data.positions"
            :index="index">
            <th>{{ position.kind }}</th>
            <td>{{ position.number }}人</td>
            <td>{{ position.detail }}</td>
          </tr>
        </tbody>
      </table>
      <p>人件費支払い：{{ item.data.salaryPayment }}</p>
    </div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
